import React from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * Confirmation modal for resetting a player's password.
 *
 * props:
 *  - show: boolean
 *  - email: string (email being reset)
 *  - handleClose: fn
 *  - handleProceed: fn
 */
const ResetPasswordVerifyOverlay = ({ show, email, handleClose, handleProceed }) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} closebutton size="lg" centered backdrop="static">
        <Modal.Header>
          <div className="admin-modal-header">RESET PASSWORD?</div>
        </Modal.Header>
        <Modal.Body>
          <div className="admin-modal-body">
            <p>
              Are you sure you want to reset the password for <strong>{email}</strong>?
            </p>
            <p>
              This will send an email to the user with a link for them to click and reset their password.
              <strong> This action will be logged.</strong>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="admin-modal-footer">
          <Button className="btn btn-primary gcotg-button admin-modal-cancel-button" onClick={handleClose}>
            Nevermind, cancel
          </Button>
          <Button className="btn btn-primary gcotg-button-secondary admin-modal-proceed-button" onClick={handleProceed}>
            Yes, reset password
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResetPasswordVerifyOverlay;

